module.exports = __webpack_public_path__ + "img/6.2c9b5503.jpg";